import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'
import { ru } from 'vuetify/locale'
import { aliases, md } from 'vuetify/iconsets/md'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'material-design-icons-iconfont/dist/material-design-icons.css'

const customTheme = {
  dark: false,
  colors: {
    bar: '#1c5551',
  },
}

const vuetify = createVuetify({
  directives,
  components: {
    ...components,
    ...labsComponents,
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
    },
  },
  locale: {
    locale: 'ru',
    messages: { ru },
  },
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
    },
  },
})

export default vuetify
